import axios from "axios";

export const FILE_BASE_URL = "https://zpteacherawards.in";

export default axios.create({
    baseURL: FILE_BASE_URL
});